import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ChronologyService } from '@services/chronology.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchService } from '@services/search.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-cwork',
  templateUrl: './cwork.component.html',
  styleUrls: ['./cwork.component.sass']
})
export class CworkComponent implements OnInit {
  suggestions$: any = [];
  error: any = { 'name': '' , endTime: '', startTime: '' };
  component = "";
  isLoading = false;
  btn_process = false;
  appCreateForm: FormGroup;
  isSubmitted = false;
  search_txt = "";
  suggestions: any = [];
  meta = "work";
  application = "chronology";
  maxDate:Date;
  constructor(private _searchService: SearchService, private fb: FormBuilder, private _chronology: ChronologyService, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.maxDate = new Date();
    this.appCreateForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      company: ['', [Validators.required, Validators.minLength(5)]],
      address: ['', [Validators.required, Validators.minLength(6)]],
      website: [],
      startTime: ['', [Validators.required]],
      endTime: ['', [Validators.required]]
    });
  }

  ngOnInit() {

  }
  get formField() {
    return this.appCreateForm.controls;
  }

  save() {
    this.isSubmitted = true;
    if (!this.appCreateForm.invalid) {

      let r = {};
      let p = this._global.paramsRemoveNull(this.appCreateForm.value);
      let metaData = {
        address: p['address'],
        company: p['company'],
        name: p['name']
      };

      this.error = { 'name': '', endTime: '', startTime: '' };
      this.btn_process = true;
      r['component'] = this.component,
        r['application'] = this.application;
      r['meta'] = this.meta;
      r['mediaType'] = 'member';
      r['name'] = p['name'];
      r['company'] = p['company'];
      r['address'] = p['address'];
      r['mediaId'] = this._global.getSessionVal('id');
      r['timeZone'] = "EST";
      r['logo'] = "";
      r['metadata'] = JSON.stringify(metaData);
      if (p.startTime) {
        r['startTime'] = new Date(p['startTime']).getTime();
      }
      if (p.endTime) {
        r['endTime'] = new Date(p['endTime']).getTime();
      }
      this._chronology.create(r, this.meta).subscribe(
        data => {

          let severity = 'success';
          let message = '';
          if (this._global.getVal(data, 'status', '') == 1) {
            message = this._global.getVal(data, 'message.info', '');
            this._global.showMessage({ type: severity, message: message });
            this.router.navigate(['/my/' + this.meta]);
          } else {
            this.btn_process = false;
            message = this._global.getVal(data, 'message.error', '');
            severity = 'warning';
            for (let key in data["errors"]) {
              this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
            }
            this._global.showMessage({ type: severity, message: message });
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }

  }
}
